import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { removeGamePack } from '@/utils/gamePacks';

interface DeleteGamePackDialogProps {
  gamePackId?: string;

  isOpen: boolean;

  setIsOpen: (isOpen: boolean) => void;
  onSubmit?: () => void;
}

export const DeleteGamePackDialog = ({
  setIsOpen,
  onSubmit,
  isOpen,
  gamePackId
}: DeleteGamePackDialogProps) => {
  const onDelete = async () => {
    if (gamePackId) {
      await removeGamePack(gamePackId);
      setIsOpen(false);
      if (onSubmit) {
        onSubmit();
      }
    }
  };

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
      <DialogTitle className="text-[24px] font-bold">Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <b>Are you sure you want to delete this Game Pack?</b> <br />
          This won’t delete the Prompts in the Game Pack. <br /> This will delete the Game Pack for
          all Organizations that have access to it.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <button className="btn btn-neutral mr-[5px]" onClick={() => setIsOpen(false)}>
          Cancel
        </button>
        <button className="btn btn-primary" onClick={async () => onDelete()}>
          Delete
        </button>
      </DialogActions>
    </Dialog>
  );
};
